import { useTranslation } from "react-i18next";
import React, { useContext } from "react";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { LangContext } from "context/language";
import colorBlueLogo from "assets/images/logo-colored.png";

const socialLinks = [
  {
    id: "facebook",
    href: "https://www.facebook.com/profile.php?id=61576964123557",
    icon: <FaFacebookF />,
  },
  { id: "twitter", href: "https://x.com/MilestonesPage", icon: <FaTwitter /> },
  {
    id: "linkedin",
    href: "https://www.linkedin.com/company/milestones-page",
    icon: <FaLinkedinIn />,
  },
];

export default function Footer() {
  const { t } = useTranslation();
  const { headerLinks } = useContext(LangContext);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="px-6">
      <div className="container max-w-[100rem] m-auto text-lg font-normal pt-[3.75rem]">
        <div className="flex flex-col xl:flex-row justify-between w-full gap-y-12 pb-32 max-w-[88rem] mx-auto">
          <div className="flex-1 max-w-[30rem]">
            <div className="relative w-[13.125rem] h-14">
              <img
                src={colorBlueLogo}
                alt="Milestones Logo"
                className="object-contain absolute inset-0"
              />
            </div>
            <p className="text-lg leading-[1.7] mt-[1.875rem] mb-8">
              Everything you’ve ever done. In one place.
            </p>
            <ul className="flex flex-row items-center gap-[0.625rem] [&_li_a]:w-[3.125rem] [&_li_a]:h-[3.125rem] [&_li]:bg-bgvariant-2 [&_li]:rounded-full [&_li]:bg-[#EDEFF3] [&_li_a]:flex [&_li_a]:items-center [&_li_a]:justify-center [&_li_a]:text-primary">
              {socialLinks.map((link) => (
                <li key={link.id}>
                  <a href={link.href} aria-label={link.id} target="_blank" rel="noreferrer">
                    {link.icon}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-1 flex flex-col sm:flex-row gap-6">
            <div className="flex-1 flex justify-start xl:justify-center">
              <div>
                <h4 className="mb-7 font-semibold text-xl">{t("quickLinks")}</h4>
                <ul className="flex flex-col gap-5">
                  {headerLinks.map((link) => (
                    <li key={link.id}>
                      <a href={`https://milestonespage.com${link.path}`}>{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="flex-1 flex justify-start xl:justify-center">
              <div>
                <h4 className="mb-7 font-semibold text-xl">{t("account")}</h4>
                <ul className="flex flex-col gap-5">
                  <li>
                    <a href={`${process.env.REACT_APP_PUBLIC_DOMAIN}/login`}>{t("signIn")}</a>
                  </li>
                  <li>
                    <a href={`${process.env.REACT_APP_PUBLIC_DOMAIN}/sign-up`}>{t("joinForFree")}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 justify-between items-start border-t border-black/10 py-14 text-xs md:text-lg">
          <ul className="flex flex-row items-center gap-8 justify-center xl:justify-start">
            <li>
              <a href="https://milestonespage.com/terms-and-conditions/">{t("termsConditions")}</a>
            </li>
            <li>
              <a href="https://milestonespage.com/privacy-policy/">{t("privacyPolicy")}</a>
            </li>
          </ul>
          <div className="text-center">
            © {`Milestones Page ${currentYear}. All Rights Reserved.`}
          </div>
          <div className="text-center xl:text-right">
            Built by{" "}
            <a href="https://loopwebdesign.com.au/" target="_blank" rel="noreferrer">
              Loop Web Design
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
